import { render, staticRenderFns } from "./TermCondition.vue?vue&type=template&id=c90112c0&scoped=true&"
import script from "./TermCondition.vue?vue&type=script&lang=js&"
export * from "./TermCondition.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/howto.scss?vue&type=style&index=0&id=c90112c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90112c0",
  null
  
)

export default component.exports